import {
    RefreshIcon,
    fadeTimingMs,
    farmsClasses,
    errFeedbackFn,
    SelDropdownIcon,
    miscClasses,
    noPermTablePrefixMsg,
    EditIcon,
    LoadingSpinner,
} from '../../utility'
import { Fade, Paper, Typography, Select, Button, MenuItem, Box } from '@mui/material';
import APIService from '../../../api/apiService';
import FarmCard from '../../farms/FarmCard';
import { useState } from 'react';
import EditFarmAliasPopup from '../Popup/EditFarmAliasPopup';

export default function _FarmsTab(props) {
    const {
        currDarkThemeClass = '',
        organization = 'Unknown',
        title = 'Farms',
        handleSetValues = () => { },
        metrcKey = '',
        setMetrcKey = () => { },
        setValues = () => { },
        metrc_id = '',
        loading = true,
        farmPerms = [],
        feedbackCX = null,
        metrc = [],
        farms = [],
        handleConfigurationsRes = () => { },
        handleErrorWithFeedback = () => { }
    } = props;

  const [openFarmActionsPopup, setOpenFarmActionsPopup] = useState(false);

    const handleMetrcChange = ({ target: { value } }) => {
        handleSetValues('metrc_id', value);
        setMetrcKey(value);
    };

    const handleRefreshData = async () => {
        if (!farmPerms?.create) return;

        handleSetValues('loading', true);

        const errConfig = {};

    // Will need to allow data_fetch=true func in collection/farm/ ?
    // Or, just update farm and metrcrooms when data_fetch = true and save their response
    // const entity = `farm/?metrc_id=${metrcKey}&data_fetch=true`;
    const entity = `farm/?data_fetch=true`;
    try {
      let response = await APIService.fetchInstance(entity);
      handleConfigurationsRes(setValues)(response);
    } catch (error) {
      handleErrorWithFeedback(feedbackCX)(setValues, errFeedbackFn(errConfig))(error);
    }
  };
  
  const handleFarmActionsPopup = () => {
    setOpenFarmActionsPopup(true);
  };

    const farmsPaperProps = {
        className: `${farmsClasses?.paper} ${currDarkThemeClass} customScroll`,
        square: true,
        variant: 'none',
        sx: {
            padding: '60px 0px'
        }
    };

    const farmsOrgPaperProps = {
        className: `${farmsClasses?.orgPaper} ${currDarkThemeClass}`,
        variant: 'none',
    };

    const farmsOrgTitleTypoProps = {
        className: `${farmsClasses?.orgTitleTypo} ${currDarkThemeClass}`,
    };

    const farmOrgNameTypoProps = {
        className: `${farmsClasses?.orgNameTypo} ${currDarkThemeClass}`,
    };

    const farmsTitleTypoProps = {
        className: `${farmsClasses?.titleTypo} ${currDarkThemeClass}`,
    };

    const farmsKeyTypoProps = {
        className: `${farmsClasses?.keyTypo} ${currDarkThemeClass}`,
    };

    const farmsKeyRefreshAddPaperProps = {
        className: `${farmsClasses?.keyRefreshAddPaper} ${currDarkThemeClass}`,
        variant: 'none',
    };

    const farmsIconProps = {
        className: `${farmsClasses?.icon} ${currDarkThemeClass}`,
    };

    const farmsKeySelProps = {
        className: `${farmsClasses?.keySelect} ${currDarkThemeClass}`,
        IconComponent: SelDropdownIcon,
        label: ' ',
        onChange: handleMetrcChange,
        value: metrc_id ?? '',
    };

    const farmsRefreshBtnProps = {
        className: `${farmsClasses?.refreshBtn} ${currDarkThemeClass}`,
        disabled: loading || !farmPerms?.create,
        onClick: handleRefreshData,
        startIcon: <RefreshIcon {...farmsIconProps} />,
    };

  const farmsActionsBtnProps = {
    // className: `${farmsClasses?.refreshBtn} ${currDarkThemeClass}`,
    disabled: loading || !farmPerms?.create,
    style: {height: '32px', minWidth: '110px', marginRight: "24px"},
    onClick: () => handleFarmActionsPopup(),
    // startIcon: <EditIcon {...farmsIconProps} />,
  };

    const farmsKeyMenuItemProps = {
        className: `${farmsClasses?.keyMenuItem} ${currDarkThemeClass}`,
        focusVisibleClassName: `${miscClasses?.menuItemFocusDark}`,
    };

    const orgKeyMenuItems = metrc?.map((e, i) => (
      <MenuItem key={i} value={e.metrc_id} {...farmsKeyMenuItemProps}>
        {e.metrc_id}{'*'.repeat(37)}
      </MenuItem>
    )) ||
    (metrcKey ? (
      <MenuItem key={`metrc-0`} value={metrcKey} {...farmsKeyMenuItemProps}>
        {metrcKey}{'*'.repeat(37)}
      </MenuItem>
    ) : (
      []
    ));

    const noEntityProps = {
        className: `${farmsClasses?.noEntityTypo} ${currDarkThemeClass}`,
    };

    const farmsListPaperProps = {
        className: `${farmsClasses?.listPaper} ${currDarkThemeClass} farmsTabContent`,
        variant: 'none',
    };

    const otherFarmCardProps = {
        org_name: organization?.org_name,
        currDarkThemeClass,
    };

  const farmsList = !farmPerms?.read ? (
  <Typography {...noEntityProps}>{noPermTablePrefixMsg} farms</Typography>
) : loading || !farms || farms.length === 0 ? (
  <LoadingSpinner 
      message="Loading Farms Data"
      currDarkThemeClass={currDarkThemeClass}
      className={`${farmsClasses?.titleTypo} ${currDarkThemeClass}`}
  />
) : (
  <Paper {...farmsListPaperProps}>
    {farms.map((e, i) => (
      <FarmCard key={i} {...e} {...otherFarmCardProps} />
    ))}
  </Paper>
  );

  const editFarmAliasPopupProps = {
    open: openFarmActionsPopup,
    onClose: () => setOpenFarmActionsPopup(false),
    currDarkThemeClass,
    values: farms,
    handleSetValues: handleSetValues,
    // metrcKey: metrcKey,
    // setMetrcKey: setMetrcKey,
  };



    
    

    return (
      <Fade in={true} timeout={fadeTimingMs}>
        <Paper {...farmsPaperProps} style={{ padding: '50px 0px' }}>
          <Paper {...farmsOrgPaperProps}>
            <Typography {...farmsOrgTitleTypoProps}>ORGANIZATION</Typography>
            <Typography {...farmOrgNameTypoProps}>{organization?.org_name ?? 'Unknown'}</Typography>
          </Paper>
          <Typography {...farmsTitleTypoProps}>{title}</Typography>
          <Typography {...farmsKeyTypoProps}>Compliance Org Key</Typography>
          <Paper {...farmsKeyRefreshAddPaperProps}
            sx={{
              ...farmsKeyRefreshAddPaperProps.sx,  justifyContent: 'space-between',  gap: 2,  padding: '8px 16px',}}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Select {...farmsKeySelProps}>{orgKeyMenuItems}</Select>
              <Button {...farmsRefreshBtnProps}>Refresh Data</Button>
            </div>
            <Button {...farmsActionsBtnProps} variant="outlined">
              Actions
            </Button>
          </Paper>
          {farmsList}
          {openFarmActionsPopup && <EditFarmAliasPopup {...editFarmAliasPopupProps} />}
        </Paper>
      </Fade>
    );
}

